import axios from "../../../../../axios";
import React from "react";
import { Link, NavLink } from "react-router-dom";

const SchedulePrePopup = ({ setPreSDelete, schedulePre_id }) => {
  const handleStatus = async (e) => {
    // console.log("click");
    e.preventDefault();
    let changeStatus = {
      status: "draft",
    };
    try {
      const res = await axios.post(
        `/api/v1/homework/preRead/updateStatus/${schedulePre_id}`,
        changeStatus
      );
      // console.log("res", res);

      res &&
        window.location.reload(
          "http://localhost:3000/PublishedHomeworkActivity"
        );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className=" p-3 AssessPopupBox shadow">
        <NavLink to={`/ScheduleEdit_PreReads`} state={{ schedulePre_id: schedulePre_id }}>
          <button className="popup_btn">Edit</button>
        </NavLink>
        <button className="popup_btn" onClick={(e) => setPreSDelete(true)}>
          Delete
        </button>
        <button className="popup_btn" onClick={handleStatus}>
          Deactivate
        </button>
      </div>
    </>
  );
};

export default SchedulePrePopup;
